import { useMemo } from 'react'

import { LodgingDoorProxy } from 'models/google_place_door'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { DataTableColumnSort } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import { useGooglePlacesDoorBaseTableCols } from '../../GooglePlaceBase/GooglePlaceDoorBaseTable/GooglePlaceBaseDoorTableColumns'
import { useHotelAmenitiesColumn } from '../../Lodging/useHotelAmenitiesColumn'
import { LODGING_DOORS_COLUMNS } from '../LodgingDoorsColumnsInfo'

export const useLodgingDoorsTableCols = ({
  sorting,
  inCampaigns,
}: {
  sorting?: DataTableColumnSort[]
  inCampaigns?: boolean
}) => {
  const { enableLodgingHotelAmenities } = useFeatureFlagService()
  const commonColumns = useGooglePlacesDoorBaseTableCols({
    sorting,
    inCampaigns,
    accesor: 'lodging',
    tableColumns: LODGING_DOORS_COLUMNS,
    linkPrefix: 'lodging/door',
  })

  const amenitiesColumn = useHotelAmenitiesColumn<
    LodgingDoorProxy,
    typeof LODGING_DOORS_COLUMNS
  >(LODGING_DOORS_COLUMNS)

  return useMemo(
    () =>
      enableLodgingHotelAmenities
        ? [...commonColumns, amenitiesColumn]
        : commonColumns,
    [commonColumns, amenitiesColumn, enableLodgingHotelAmenities]
  )
}
